import { toast } from "react-hot-toast";
import moment from "moment";

export const RESTRICTED_STAFF_ID = "686264d4cb77e7121f7d047c";

export const isUserLoggedOut = () => {
	localStorage?.clear();
	window.location.href = "/login";
	return;
};

export const getToken = () => {
	const userString = localStorage.getItem("user");
	return userString ? JSON.parse(userString) : null;
};

// Common error handling function
export const handleErrors = (err) => {
	try {
		const errorMessages = err?.response?.data;
		console.log(errorMessages)
		if (errorMessages?.status === false && err?.response?.status === 401) {
			// Call isUserLoggedOut function or perform logout logic here
			isUserLoggedOut();
		} else {
			if (errorMessages?.message) {
				toast.error(errorMessages?.message);
			}
			// else if(){
			// 	toast.error(errorMessages?.message);
			// }
			else {
				toast.error("An error occurred, Please retry again later");
			}
		}
	} catch (error) {
		// Handle any additional errors during error handling
		console.error("Error handling the error:", error);
	}
};

export const formatDate = (dateString) => {
	const date = new Date(dateString);
	const day = String(date.getDate()).padStart(2, "0");
	const month = String(date.getMonth() + 1).padStart(2, "0");
	const year = date.getFullYear();

	return `${day}-${month}-${year} `;
};

export function shortname(file) {
	const filename = file;
	const shortname =
		filename?.length > 14
			? filename?.substr(0, 8) + "..." + filename?.substr(-9)
			: filename;
	return <>{shortname}</>;
}

// Utility function to truncate a string and append ellipsis if needed
export const truncateString = (str, maxLength) => {
	return str.length > maxLength ? str.substring(0, maxLength) + "...." : str;
};

// Utility function to get Tailwind CSS class based on status
export const getStatusColorClass = (status) => {
	switch (status) {
		case "active":
			return "px-2 pb-1 bg-[#2dce89] text-[#fff] rounded-md"; // Green color for "Activate"
		case "deactive":
			return "px-2 pb-1 text-[#fff] bg-[#FFF2E8] rounded-md"; // Yellow color for "Deactivate"
		case "deleted":
			return "px-2 pb-1 text-[#F5222D] bg-[#FFF1F0]"; // Red color for "Deleted"
		case "pending":
			return "px-3 pb-1 bg-[#FF8C2E] text-[#fff] rounded-full";
		case "Cancel Pending":
			return "px-3 pb-1 bg-[#FF8C2E] text-[#fff] rounded-full";
		case "Refund Pending":
			return "px-3 pb-1 bg-[#FF8C2E] text-[#fff] rounded-full";
		case "Confirm":
			return "px-3 pb-1 bg-confirmBooking text-[#fff] rounded-full";
		case "SOU Cancel Confirm":
			return "px-3 pb-1 bg-confirmBooking text-[#fff] rounded-full";
		case "Refunded":
			return "px-3 pb-1 bg-confirmBooking text-[#fff] rounded-full";
		case "progress":
			return "px-3 pb-1 bg-upComingBooking text-[#fff] rounded-full";
		case "processing":
			return "px-3 pb-1 bg-upComingBooking text-[#fff] rounded-full";
		case "confirm":
			return "px-3 pb-1 bg-confirmBooking text-[#fff] rounded-full";
		case "cancel":
			return "px-2 pb-1 text-[#fff] bg-[#FF0000] rounded-full";
		case "Cancel":
			return "px-2 pb-1 text-[#fff] bg-[#FF0000] rounded-full";
		case "Cancel By User":
			return "px-2 pb-1 text-[#fff] bg-[#FF0000] rounded-full";
		case "Cancel By Agent":
			return "px-2 pb-1 text-[#fff] bg-[#FF0000] rounded-full";
		case "Cancel By Admin":
			return "px-2 pb-1 text-[#fff] bg-[#FF0000] rounded-full";
		case "Specific Cancel":
			return "px-2 pb-1 text-[#fff] bg-[#FF0000] rounded-full";
		case "Cancel Confirm":
			return "px-2 pb-1 text-[#fff] bg-confirmBooking rounded-full";
		case "failed":
			return "px-2 pb-1 text-[#F5222D] bg-[#FFF1F0] rounded-full";
		case "rejected":
			return "px-2 pb-1 text-[#F5222D] bg-[#FFF1F0] rounded-full";
		case "paid":
			return "px-3 pb-1 bg-confirmBooking text-[#fff] rounded-full";
		case "waiting":
			return "px-3 pb-1 bg-[#FF8C2E] text-[#fff] rounded-full";
		case "confirm from jyoti":
			return "px-3 pb-1 bg-upComingBooking text-[#fff] rounded-full";
		case "CANCELLED":
			return "px-2 pb-1 text-[#fff] bg-[#FF0000] rounded-full";
		case "FAILED":
			return "px-2 pb-1 text-[#F5222D] bg-[#FFF1F0] rounded-full";
		case "REFUNDED":
			return "px-3 pb-1 bg-[#FF8C2E] text-[#fff] rounded-full";
		default:
			return "px-2 pb-1 text-white bg-gray-500 rounded-full"; // Default color (you can set this to another color if needed)
	}
};

export function DateTimeDisplay(datetime) {
	const formattedDateTime = new Date(datetime).toISOString().slice(0, 16);

	return formattedDateTime;
}

export function formatToINR(amount) {
	return new Intl.NumberFormat("en-IN", {
		style: "currency",
		currency: "INR",
		minimumFractionDigits: 2,
		maximumFractionDigits: 2,
	}).format(amount);
}

/**
 * Format a signed balance amount.
 * Negative (credit) values display as: (-) ₹500.00
 * Positive (debit) values display as:       ₹500.00
 */
export function formatSignedINR(amount) {
	const num = Number(amount) || 0;
	const abs = new Intl.NumberFormat("en-IN", {
		style: "currency",
		currency: "INR",
		minimumFractionDigits: 2,
		maximumFractionDigits: 2,
	}).format(Math.abs(num));
	
	if (num === 0) return abs;
	return num > 0 ? `${abs} Dr` : `${abs} Cr`;
}

export const formatBookingDateUTCtoIST = (
	dateString,
	format = "YYYY-MM-DD HH:mm:ss"
) => {
	if (!dateString) return "-";
	const m = moment(dateString);
	if (!m.isValid()) return "-";
	return m.utcOffset("+05:30").format(format);
};

export const formatDateCustomFormate = (
	dateString,
	format = "YYYY-MM-DD HH:mm:ss"
) => {
	if (!dateString) return "-";
	const m = moment(dateString);
	if (!m.isValid()) return "-";
	return m.utcOffset("+00:00").format(format);
};

export const showSuccessToast = (message) => {
	toast.success(message, {
		style: {
			border: "1px solid #28a745", // Green border
			padding: "20px",
			color: "#28a745", // Green text color
			backgroundColor: "#E6F4EA", // Light green background
		},
		iconTheme: {
			primary: "#28a745", // Green icon
			secondary: "#FFFFFF", // White background for the icon
		},
	});
};

export const showErrorToast = (message) => {
	toast.error(message, {
		style: {
			border: "1px solid #b00020",
			padding: "20px",
			color: "#b00020",
		},
		iconTheme: {
			primary: "#b00020",
			secondary: "#FFFAEE",
		},
	});
};

export const getHotelStatusColor = (status) => {
	const statusColors = {
		pending: "bg-[#CC8805CC]", // Orange
		approved: "bg-[#40A648]", // Green
		notApproved: "bg-[#FF5733]", // Reddish Orange
		activate: "bg-[#1B69FFCC]", // Blue
		deactivate: "bg-[#6C757D]", // Gray
	};

	return statusColors[status] || "bg-gray-500"; // Default color
};

export const convertToIST = (unixSeconds) => {
	if (!unixSeconds) return null;
	const dateInIST = moment.unix(unixSeconds).utcOffset("+05:30");
	return dateInIST.format("DD/MM/YYYY hh:mm:ss A");
};

/**
 * Post to an external URL by creating a hidden form and submitting it.
 * @param {string} url The URL to post to.
 * @param {Object} data The data to include in the hidden form as key-value pairs.
 * @param {string} target The target for the form submission (e.g., '_blank').
 */
export const postToExternalUrl = (url, data, target = "_blank") => {
	const form = document.createElement("form");
	form.method = "POST";
	form.action = url;
	form.target = target;

	Object.entries(data).forEach(([key, value]) => {
		const input = document.createElement("input");
		input.type = "hidden";
		input.name = key;
		input.value = value;
		form.appendChild(input);
	});

	document.body.appendChild(form);
	form.submit();
	document.body.removeChild(form);
};

export const numberToWords = (num) => {
	const ones = [
		"",
		"One",
		"Two",
		"Three",
		"Four",
		"Five",
		"Six",
		"Seven",
		"Eight",
		"Nine",
		"Ten",
		"Eleven",
		"Twelve",
		"Thirteen",
		"Fourteen",
		"Fifteen",
		"Sixteen",
		"Seventeen",
		"Eighteen",
		"Nineteen",
	];
	const tens = [
		"",
		"",
		"Twenty",
		"Thirty",
		"Forty",
		"Fifty",
		"Sixty",
		"Seventy",
		"Eighty",
		"Ninety",
	];
	const thousands = ["", "Thousand", "Lakh", "Crore"];

	if (isNaN(num)) return "Invalid number";

	num = parseFloat(num).toFixed(2);
	const [wholePart, decimalPart] = num.split(".");

	const convertBelowThousand = (n) => {
		let str = "";
		if (n >= 100) {
			str += ones[Math.floor(n / 100)] + " Hundred ";
			n %= 100;
		}
		if (n >= 20) {
			str += tens[Math.floor(n / 10)] + " ";
			n %= 10;
		}
		if (n > 0) {
			str += ones[n] + " ";
		}
		return str.trim();
	};

	const formatIndianGroups = (num) => {
		const rev = num.split("").reverse().join("");
		let formatted = "";

		// Group into Indian number format
		for (let i = 0; i < rev.length; i++) {
			if (i === 3 || (i > 3 && (i - 1) % 2 === 0)) {
				formatted += ","; // Add a comma after every two digits beyond the thousands place
			}
			formatted += rev[i];
		}
		return formatted.split("").reverse().join("").split(",").map(Number);
	};

	const wholeNumArr = formatIndianGroups(wholePart);
	let result = wholeNumArr
		.map((chunk, index) => {
			if (chunk === 0) return "";
			const placeValue = thousands[wholeNumArr.length - index - 1] || "";
			return `${convertBelowThousand(chunk)} ${placeValue}`.trim();
		})
		.join(" ")
		.trim();

	if (decimalPart && parseInt(decimalPart) > 0) {
		result += " and " + convertBelowThousand(parseInt(decimalPart)) + " Paise";
	}

	return result.trim();
};

